import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';
import { clearJwt } from 'src/utils/jwt';
import { isAuth0Session } from 'src/utils/tokenProvider';

/**
 * Logs the user out of whichever session they have.
 *
 * A native session just clears local state and reloads, as it always has. An Auth0 session
 * additionally has to end the session at the tenant - otherwise the next visit silently
 * re-authenticates - and let the SDK clear its own cached refresh token.
 */
export const useLogout = (): (() => void) => {
    // Safe to call unconditionally: outside Auth0Provider this reads the default context, and we
    // only invoke logout() for a session we know was established through the provider.
    const { logout } = useAuth0();

    return useCallback(() => {
        const wasAuth0 = isAuth0Session();
        clearJwt();

        if (wasAuth0) {
            void logout({ logoutParams: { returnTo: window.location.origin } });
            return;
        }

        location.reload();
    }, [logout]);
};
